export default {
    "goal": "Mål.",
    "goal_team_only": "{{score}}Mål {{scoring_team}}!",
    "goal_team_player": "{{score}}Mål {{scoring_team}}! Scoring af {{scoring_player}}.",
    "own_goal_team_player": "{{score}}Mål {{scoring_team}}. Selvmål af {{scoring_player}}.",

    "yellow_card": "Gult kort.",
    "yellow_card_team_only": "Gult kort {{team}}.",
    "yellow_card_team_player": "Gult kort {{team}}: {{player}}.",

    "red_card": "Rødt kort.",
    "red_card_team_only": "Rødt kort {{team}}.",
    "red_card_team_player": "Rødt kort {{team}}: {{player}}.",

    "penalty": "Straffespark.",
    "penalty_by_team": "Straffespark, {{team}}.",

    "phase_kickoff": "Kickoff.",
    "kickoff_1st_half": "Kickoff første halvleg.",
    "kickoff_2nd_half": "Kickoff anden halvleg.",
    "kickoff_1st_overtime": "Kickoff første ekstrahalvleg.",
    "kickoff_2nd_overtime": "Kickoff anden ekstrahalvleg.",
    "start_of_penalties": "Straffesparkskonkurrence.",

    "phase_end": "Pause.",
    "end_1st_half": "Pause.",
    "end_2nd_half": "Pause før ekstra tid.",
    "end_1st_overtime": "Pause ekstra tid.",
    "end_2nd_overtime": "Pause før straffesparkskonkurrence.",

    "game_over": "Kampen slut.",
    "game_over_1": "Kampen slut, {{winning_team}} tager sejren i {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_2": "Kampen slut, resultatet blev uafgjort i {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_3": "Kampen slut, {{winning_team}} tager sejren. {{score_home}}-{{score_visiting}}",
    "game_over_4": "Kampen slut, resultatet blev uafgjort. {{score_home}}-{{score_visiting}}",

    "shot": "Skud",
    "blocked_shot": "Blokeret skud",
    "shot_on_goal": "Skud på mål",
    "shot_wide": "Skud udenfor mål",
    "shot_on_bar": "Skud på overliggeren",
    "shot_on_post": "Skud på stolpen",

    "blocked_shot_team": "Skud af {{team}}. Skud blokeret.",
    "blocked_shot_team_player": "Skud af {{player}}, {{team}}. Skud blokeret.",

    "heading": "Hovedstød",
    "heading_on_goal": "Hovedstød på mål",
    "heading_wide": "Hovedstød forbi mål",
    "heading_on_bar": "Hovedstød på overliggeren",
    "heading_on_post": "Hovedstød på stolpen",

    "penalty_miss": "Misset straffespark",

    "shot_by_team": "{{shot_description}} af {{team}}.",
    "shot_by_player": "{{shot_description}} af {{player}}, {{team}}.",

    "corner": "Hjørnespark.",
    "corner_by_team": "Hjørnespark, {{team}}.",

    "offside": "Offside.",
    "offside_by_team": "Offside, {{team}}.",
    "offside_by_player": "{{player}} offside, {{team}}.",

    "throw_in": "Indkast.",
    "throw_in_by_team": "Indkast, {{team}}.",

    "save": "Redning.",
    "save_by_team": "Redning, {{team}}.",

    "free_kick": "Frispark.",
    "free_kick_by_team": "Frispark, {{team}}.",

    "injury": "Skade.",

    "interesting_event": "Interessant hændelse.",

    "substitution": "Udskiftning.",
    "substitution_team": "Udskiftning, {{team}}.",
    "substitution_player_in_out": "{{player_out}} ud, {{player_in}} ind.",

    "medical_assistance": "Medicinsk assistance.",
    "medical_assistance_player": "Medicinsk assistance, {{player}}.",
}


// WEBPACK FOOTER //
// ./src/js/include/translations/Danish.js